import edApi from "@/public/utils/edApi";
const $edApi = edApi();
const state = {
    openSuggest: false, //是否显示推荐相关模块
    editorTags: [], //搜索分类及编辑标签
    rolesTags: [],
    interest: null, //设置的兴趣（二级分类）
    hidedInterest: [], //用户兴趣分类
    likeIds: [],
    collectIds: [],
    boughtWorks: [],
    //审核面板用到的
    showReviewModify: false, //审核时管理人员修改作品信息的编辑框
    showUserWorks: false,
    activedTab: 0, // 社区个人主页默认选中tab

    previewContext: false,
    showPay: false,
    showCredit: false,
    activeWork: {
        author: "",
        created_at: "",
        description: "",
        exp: 2147483647,
        id: 653,
        nick_name: "",
        path: "",
        price: "",
        sign: "",
        title: "",
        url: "",
        tags: "",
    },
    visitUser: {
        id: undefined,
        fuser: false, //是否是至尊会员
        nickName: "",
        profile: "",
        avatar: "",
    },
    followIds: [],
    getFollowDone: false,
    parttime: false, //当前用户是否为兼职人员

    activeAlbum: {
        title: "",
        id: 0,
        cover_url: "",
    },
    albumList: [],
    activeAlbumID: -1,
    albumPageStatus: "default",
    libID: [],
    tagID: 0,

    templateLang: "en",
    showAllAlbumBreadcrumb: false,
    notInitTemplates: false,
};

const mutations = {
    setLibID(state, ids) {
        state.libID = ids;
    },
    setTagID(state, id) {
        state.tagID = id;
    },
    like(state, id) {
        state.likeIds.push(id);
    },
    dislike(state, id) {
        state.likeIds.splice(state.likeIds.indexOf(id), 1);
    },
    collect(state, id) {
        state.collectIds.push(id);
    },
    disCollect(state, id) {
        state.collectIds.splice(state.collectIds.indexOf(id), 1);
    },
    toTplCenter(state, payload) {
        state[payload.name] = payload.data;
    },
    toActiveWork(state, payload) {
        state.activeWork = payload;
    },
    toVisitUser(state, payload) {
        for (let key in payload) {
            state.visitUser[key] = payload[key];
        }
    },
    setPartTime(state) {
        state.parttime = true;
    },
    setActiveAlbum(state, payload) {
        state.activeAlbum = payload;
    },
};

const actions = {
    async getTagClass({ state }, playload) {
        await new Promise((res, rej) => {
            $edApi.getTagClass(playload).then((data) => {
                state.editorTags = data;
                res(null);
            });
        });
        await new Promise((res, rej) => {
            $edApi.getRoleClass(playload).then((data) => {
                state.rolesTags = data || [];
                res(null);
            });
        });
        return Promise.resolve();
    },
    getOwnInterest({ state, rootGetters }) {
        let params = {
            id: rootGetters.apiParam.id,
            token: rootGetters.apiParam.token,
            choose: 1,
        };
        $edApi.getOwnInterest(params).then((data) => {
            state.interest = data;
        });
        params.choose = 0;
        $edApi.getOwnInterest(params).then((data) => {
            state.hidedInterest = data;
        });
    },
    async getIds({ state, rootGetters }) {
        //获取收藏、点赞和已购买的作品的id

        await new Promise((res, rej) => {
            $edApi
                .getLikeAndCollectWorks(
                    Object.assign(rootGetters.apiParam, {
                        type: "like",
                    })
                )
                .then((data) => {
                    state.likeIds = [];
                    data.forEach((item) => {
                        state.likeIds.push(item.id);
                    });
                    res();
                })
                .catch(() => {
                    res();
                });
        });
        await new Promise((res, rej) => {
            $edApi
                .getLikeAndCollectWorks(
                    Object.assign(rootGetters.apiParam, {
                        type: "collect",
                    })
                )
                .then((data) => {
                    state.collectIds = [];
                    data.forEach((item) => {
                        if (!state.collectIds.includes(item.id)) {
                            state.collectIds.push(item.id);
                        }
                    });
                    res();
                })
                .catch(() => {
                    res();
                });
        });
        return Promise.resolve();
    },
    getBoughtWorks({ state, rootGetters }) {
        return new Promise((rs, rj) => {
            $edApi
                .getBoughtWorks(rootGetters.apiParam)
                .then((works) => {
                    state.boughtWorks = works;
                    rs();
                })
                .catch(() => {
                    rs();
                });
        });
    },
    //获取所有关注的人的id
    getOwnRelationships({ state, rootGetters }) {
        return new Promise((rs, rj) => {
            $edApi
                .getRelationships(rootGetters.apiParam)
                .then((res) => {
                    let ids = [];
                    res.follow.forEach((item) => {
                        ids.push(item.user_id);
                    });
                    state.followIds = ids;
                    state.getFollowDone = true;
                    rs();
                })
                .catch(() => {
                    rs();
                });
        });
    },
};
export default {
    state,
    mutations,
    actions,
};
